<script>
import FLightweightCharts from "@/components/core/FLightweightCharts/FLightweightCharts.vue";
import gql from "graphql-tag";
import {formatNumberByLocale} from "../filters";
import {toInt} from "@/utils";
import {pollingMixin} from "@/mixins/polling";

export default {
    name: "BlockTimestampAggregationsChart",

    mixins: [pollingMixin],

    components: {FLightweightCharts},

    props: {
        title: {
            type: String,
            default: ''
        },
        interval: {
            type: Number,
            default: 10010,
        },
        subject: {
            type: String,
            default: 'TXS_COUNT'
        },
        decimals: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            series: [],
            num: 0
        }
    },

    mounted() {
        setTimeout(() => {
            this.update(true);
        }, 1050);

        this._polling.start(
            'txs-per-second',
            () => { this.update() },
            this.interval
        );
    },

    methods: {
        async update(firstUpdate) {
            const series = await this.fetchBlockTimestampAggregations(this.subject);
            const serie = this.transformSeries(series);
            const bar = serie[serie.length - 1];

            if (bar) {
                this.num = bar.value;
            }

            if (this.subject === 'TXS_COUNT') {
                this.$store.commit('updateLastTP10S', serie);
            } else if (this.subject === 'GAS_USED') {
                this.$store.commit('updateLastGP10S', serie);
            }

            if (!firstUpdate) {
                if (this.$refs.chart) {
                    this.$refs.chart.addBar(bar);
                }
            } else {
                this.series = serie;
            }
        },

        async fetchBlockTimestampAggregations(subject = '') {
            const data = await this.$apollo.query({
                query: gql`
            query GetBlockTimestampAggregations($subject: AggSubject!) {
                blockTimestampAggregations(subject: $subject) {
                    timestamp
                    value
                }
            }
                `,
                variables: { subject },
                fetchPolicy: 'network-only',
                client: 'sonic'
            });

            return data.data.blockTimestampAggregations || [];
        },

        transformSeries(series, convertToSeconds = true) {
            return series.map((item) => {
                let value = toInt(item.value);

                if (convertToSeconds) {
                    value = value / 10;
                }

                return {
                    time: item.timestamp,
                    value,
                };
            });
        },

        formatNumberByLocale,
    }
}
</script>

<template>
    <div class="dailyblocks">
        <div class="chart_label">
            <h2 id="dailyblocks_l">{{ title }}</h2>
            <div class="chart_num">{{ formatNumberByLocale(num, decimals) }}</div>
        </div>
        <FLightweightCharts
            ref="chart"
            :series="series"
            series-type="area"
            timestamp-to-local-time-zone
            :fit-content="true"
            :height="212"
            :price-scale-min="0"
            :price-scale-max="'auto'"
            :options="{
                handleScroll: false,
                handleScale: false,
                // timeScale: { visible: false },
                timeScale: { timeVisible: true },
            }"
            :series-options="{
                priceLineVisible: false,
                priceFormat: { type: 'volume', precision: 2, minMove: 1 },
                priceScale: {
                    scaleMargins: {
                        top: 0.05,
                        bottom: 0.02,
                    },
                },
            }"
        />
    </div>
</template>
